namespace advisorop.components.servicer {

    class ServicerOperationController {
        public advisorId;
        $router;
        user: domains.identity.IUser;
        show: string = "";
        firmId: number = 0;
        titleSuffix: string = "";
        PeriodicWithIssuesCount: number;
        PeriodicDepIssuesCount: number;
        NonzeroFundingIssuesCount: number;
        CashMonitorIssuesCount: number;
        NegcashMonitorIssuesCount: number;
        OrionModelMonitorIssuesCount: number;
        OrionFeeMonitorIssuesCount: number;
        BillingStyleMonitorIssuesCount: number;
        OrionAccSyncMonitorIssuesCount: number;
        UncategorizedSecuritiesMonitorIssuesCount: number;
        RMDTrackingIssuesCount: number;
        OrionHighCashModelMonitorIssuesCount: number;
        OrionHighCashNonModelMonitorIssuesCount: number;

        static $inject = ["identityService", "servicerService"];
        constructor(private identityService: services.IdentityService,
            private servicerService: services.ServicerService) {

        }

        // If we want to reinstate this, do not do it as function, set a variable.
        //isServicerAdmin(): boolean {
        //    return (this.user.role == domains.AdvisoryRoles.SERVICER_ADMIN.toString());
        //}

        $onInit(): void {
            this.advisorId = 1;

            this.identityService.getUserPromise().then(response => {
                this.user = response;
            });
        }

        $routerOnActivate(next, previous) {
            this.show = <string>next.params.show;
        }
    }



    class ServicerOperation implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = ServicerOperationController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/servicer-operation.html';
        }
    }
    angular.module(Constants.APP).component("servicerOperation", new ServicerOperation());


}